"use client";

import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
} from "@/components/ui/navigation-menu";
import Link from "next/link";
import React from "react";

interface MenuItem {
  label: string;
  href: string;
  external?: boolean;
}

const menuItems: MenuItem[] = [
  { label: "Token", href: "/token" },
  { label: "Protocol", href: "/protocol" },
  { label: "Community", href: "/community" },
  { label: "Docs", href: "https://docs.blokcapital.io/", external: true },

];

const Menu = () => {
  return (
    <NavigationMenu>
      <NavigationMenuList className="gap-6">
        {menuItems.map(({ label, href, external }) => (
          <NavigationMenuItem key={label}>
            <Link href={href} legacyBehavior passHref>
              <NavigationMenuLink
                className="text-base font-semibold text-muted-foreground hover:text-foreground transition-colors duration-200"
                {...(external
                  ? { target: "_blank", rel: "noopener noreferrer" }
                  : {})}
              >
                {label}
              </NavigationMenuLink>
            </Link>
          </NavigationMenuItem>
        ))}
      </NavigationMenuList>
    </NavigationMenu>
  );
};

export default Menu;
